import { useMemo } from 'react';
import PropTypes from 'prop-types';
import EditIcon from '@mui/icons-material/Edit';
import WorkflowSection from '../Section/WorkflowSection';
import '../Section/section.css';
import WorkflowButton from '../Section/WorkflowButton';
import { useTicketType, ValidTicketTypes } from '../../../hooks/useTicketTypeHook';
import { getSignatureDocuments } from '../../../utils/WorkflowUtil';

const SignAuthorizationRequest = ({ taxState, onWorkflowButtonAction }) => {
    const { ticketType } = useTicketType(taxState);
    
    const signatureDocs = useMemo(() => 
        getSignatureDocuments(taxState)
    , [taxState?.additional_docs]);

    if (signatureDocs.length === 0) {
        return null;
    }

    const isAlternate = false;
    const isRTE = ticketType.toLowerCase() === ValidTicketTypes.RTE;

    const renderButton = (labelProps, contextData) => {
        const commonProps = {
            buttonKey: 'signature_docs',
            text: 'WorkflowPanel.AuthorizationRequest.titleWF',
            textProps: labelProps,
            showChevron: "true",
            ticketType,
            onClick: () => onWorkflowButtonAction('additional_docs', taxState.taxYear, contextData),
            children: <EditIcon className="large_mi_icon" />
        };

        return <WorkflowButton {...commonProps} customClassName="signature-doc-button" />;
    };

    return (
        <WorkflowSection 
            titleKey=''
            canClose={false}
            isAlternate={isAlternate} 
            ticketType={taxState.ticket_type} 
            hideHeader
        >
            {signatureDocs.map((docState, index) => {
                const firstName = docState.document_name_en || 
                    (docState.is_spouse ? taxState.spouse_firstName : taxState.primary_firstName);
                
                const contextData = {
                    document_type: docState.document_type,
                    is_spouse: docState.is_spouse,
                    spouseFirstName: taxState.spouse_firstName,
                    primaryFirstName: taxState.primary_firstName,
                    cdm_file_id: docState.cdm_file_id
                };

                return (
                    <div key={`signature_docs_${docState.document_type}_${index}`}>
                        {renderButton({ FirstName: firstName }, contextData)}
                    </div>
                );
            })}
        </WorkflowSection>
    )
}

SignAuthorizationRequest.propTypes = {
    currentYear: PropTypes.number.isRequired,
    onWorkflowButtonAction: PropTypes.func.isRequired,
    taxState: PropTypes.shape({
        taxYear: PropTypes.number.isRequired,
        ticket_type: PropTypes.string,
        primary_firstName: PropTypes.string.isRequired,
        spouse_firstName: PropTypes.string,
        additional_docs: PropTypes.arrayOf(PropTypes.shape({
            document_type: PropTypes.string.isRequired,
            document_name_en: PropTypes.string,
            is_spouse: PropTypes.bool,
            is_completed: PropTypes.bool,
            cdm_file_id: PropTypes.string
        }))
    }).isRequired
}

export default SignAuthorizationRequest;